import apiSlice from "./apiSlice";
const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        updateUserStatus: builder.mutation({
            query: (userId) => ({
                url: `account/disable/${userId}`,
                method: 'PATCH',
            }),
            invalidatesTags: ['UserListTag']
        }),
        getDesignationList: builder.query({
            query: (req) => ({
                url: `account/DesignationList`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getUsersList: builder.query({
            query: (req) => ({
                url: `account/List`,
                params: req
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["UserListTag"],
        }),
    }),
});

export const {
    useUpdateUserStatusMutation,
    useGetDesignationListQuery,
    useGetUsersListQuery
} = userApiSlice;
